import React, { Component } from 'react';
interface Product {
  name: string;
  image: string;
  href: string;
}
const products: Product[] = [{
  name: 'EDMMax 433S Diamond Abrasive Saw',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/1acd1745dc37be9bdbfc0906b7e1b5f3/large-edm-max-433-s-diamond-abrasive-saw.jpg',
  href: '/listings/6618724-edmmax-433s-diamond-abrasive-saw'
}, {
  name: 'EDMMax 868S Diamond Abrasive Saw',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/a4bf718107a779e939238903347f6d5a/large-edm-max-868-s.jpg',
  href: '/listings/6618715-edmmax-868s-diamond-abrasive-saw'
}];
export function ProductsSection() {
  return <section data-id="element-1779">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-1780">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-1781">
          Diamond Abrasive Saw Machines
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-1782">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1783">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1784">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-1785">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-1786" />
              </a>
              <div className="p-5 flex flex-col flex-grow" data-id="element-1787">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-1788">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-1789">
                    {product.name}
                  </h3>
                </a>
                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-1790">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-1791">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-1792">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}